import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

import { Alert, AlertType } from '@app/_models';

@Injectable({ providedIn: 'root' })
export class AlertService {
    private subject = new Subject<Alert>();
    private defaultId = 'default-alert';

    // enable subscribing to alerts observable
    onAlert(id = this.defaultId): Observable<Alert> {
        return this.subject.asObservable().pipe(filter(x => x && x.id === id));
    }

    // convenience methods
    success(message: string, details?: any, options?: any) {
        message = this.sanitize(message);
        details = this.sanitize(details);
        this.alert(new Alert({ ...options, type: AlertType.Success, message, details }));
    }

    error(message: string, details?: any, options?: any) {
        message = this.sanitize(message);
        details = this.sanitize(details);
        this.alert(new Alert({ ...options, type: AlertType.Error, message, details }));
    }

    info(message: string, details?: any, options?: any) {
        message = this.sanitize(message);
        details = this.sanitize(details);
        this.alert(new Alert({ ...options, type: AlertType.Info, message, details }));
    }

    warn(message: string, details?: any, options?: any) {
        message = this.sanitize(message);
        details = this.sanitize(details);
        this.alert(new Alert({ ...options, type: AlertType.Warning, message, details }));
    }

    // main alert method    
    alert(alert: Alert) {
        alert.id = alert.id || this.defaultId;
        this.subject.next(alert);
    }

    // clear alerts
    clear(id = this.defaultId) {
        this.subject.next(new Alert({ id }));
    }

    private sanitize(str: string) {
        if (str != null && str != undefined) {
            str = str.replace('<script>', '');
            str = str.replace('</script>', '');
        }
        return str;
    }
}